Layout.store.state = {
    menuExpanded: false,
    searchExpanded: false,
    errorText: '',
    messageText: '',
};